import cloneDeep from 'lodash/cloneDeep'
const defaults = {
  children: 'children',
}

// 返回的是树的一个节点
// 类似数组的find ，只会搜索匹配的第一个。
const find = (data, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)

  let result = data.find(c => predicate(c))
  if (result) {
    return result
  }
  for (let i = 0; i < data.length; i++) {
    let item = data[i]

    if (item[config.children] && item[config.children].length > 0) {
      result = find(item[config.children], predicate, config)
      if (result) {
        return result
      }
    }
  }
  return result
}
// 返回的是包含多个树节点 的数组
// 数组的每一项都是一个树节点
const findAll = (treeData, predicate, options = {}) => {
  const tData = cloneDeep(treeData)
  let arr = treeToArray(tData, options).filter(c => predicate(c))
  return arr
}
// 返回的是树的一个节点
// 类似数组的find ，只会搜索匹配的第一个，只是这里返回的是匹配元素的父节点。
const findParent = (data, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)

  let parent = undefined
  for (let i = 0; i < data.length; i++) {
    if (parent) return parent

    let item = data[i]

    if (item[config.children] && item[config.children].length > 0) {
      let child = item[config.children].filter(c => predicate(c))
      if (child.length > 0) {
        parent = item
      }

      if (parent === undefined) {
        parent = findParent(item[config.children], predicate, config)
      } else {
        break
      }
    }
  }
  return parent
}

// 由index构成，以短横线分割，如 0-0-0
const findIndexId = (treeData, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)

  let indexId = ''
  function wlk(o, loopId) {
    for (let i = 0; i < o.length; i++) {
      let originItem = cloneDeep(o[i])
      let result = predicate(originItem)
      if (result) {
        indexId = loopId ? `${loopId}-${i}` : `${i}`
        break
      } else {
        if (originItem[config.children] && originItem[config.children].length) {
          let newLoopId = loopId ? `${loopId}-${i}` : `${i}`
          wlk(originItem[config.children], newLoopId)
        }
      }
    }
  }
  wlk(treeData, '')
  return indexId
}
const findByIndexId = (treeData, indexId, options = {}) => {
  let config = Object.assign({}, defaults, options)
  let result = treeData
  const indexIdArr = indexId.split('-')
  let length = indexIdArr.length
  let matchCount = 0
  while (indexIdArr.length) {
    const index = indexIdArr.shift()
    if (result && result[index]) {
      matchCount++
      if (matchCount === length) {
        // 无下层了，直接返回当前；
        return result[index]
      } else {
        result = result[index][config.children]
      }
    }
  }
}
const findAllParents = (treeData, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)
  let result = []
  const indexId = findIndexId(treeData, predicate, config)
  if (indexId) {
    const indexIdArr = indexId.split('-')
    for (let index = 1; index < indexIdArr.length; index++) {
      let _indexId = ''
      for (let i = 0; i < index; i++) {
        _indexId ? (_indexId += `-${indexIdArr[i]}`) : (_indexId += `${indexIdArr[i]}`)
      }
      const parent = findByIndexId(treeData, _indexId)
      result.push(parent)
    }
  }
  return result
}
const findAllChildren = (data, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)
  let result = []
  const node = find(data, predicate, config)

  if (node && node.children && node.children.length) {
    function wlk(o) {
      for (let i = 0; i < o.length; i++) {
        let originItem = cloneDeep(o[i])
        result.push(originItem)
        if (originItem[config.children] && originItem[config.children].length) {
          wlk(originItem[config.children])
        }
      }
    }
    wlk(node.children)
  }
  return result
}
// map 返回值是整颗树
// 类似数组的map,map 函数忽略所有对children的操作
const map = (treeData, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)
  const resultTree = cloneDeep(treeData)
  // o 是老树，t是新树，循环以老树为基准。
  function wlk(o, t, loopId) {
    for (let i = 0; i < o.length; i++) {
      const indexId = loopId ? `${loopId}-${i}` : `${i}`
      let originItem = o[i]
      // 确保children不受改变
      const c = cloneDeep(t[i][config.children])
      let newItem = predicate(t[i], indexId)
      if (Object.prototype.toString.call(newItem) === '[object Object]') {
        newItem[config.children] = c
      }
      if (newItem) {
        t[i] = newItem
      } else {
        t[i][config.children] = c
      }
      if (originItem[config.children] && originItem[config.children].length) {
        wlk(originItem[config.children], t[i][config.children], indexId)
      }
    }
  }
  wlk(treeData, resultTree, '')

  return resultTree
}
// filter返回值是整颗树
// filter的树必须每级都满足
const filter = (treeData, predicate, options = {}) => {
  let config = Object.assign({}, defaults, options)
  const startTree = cloneDeep(treeData)
  const resultTree = cloneDeep(treeData)
  // o 是老树，t是新树，循环以老树为基准。
  function wlk(o, t) {
    for (let i = 0; i < o.length; i++) {
      let originItem = o[i]
      let result = predicate(originItem)
      if (!result) {
        t[i] = null
      }
      if (originItem[config.children] && originItem[config.children].length) {
        if (t[i] && t[i][config.children]) {
          wlk(originItem[config.children], t[i][config.children])
        }
      }
    }
    let nullIndex = t.indexOf(null)
    while (nullIndex !== -1) {
      t.splice(nullIndex, 1)
      nullIndex = t.indexOf(null)
    }
  }
  wlk(startTree, resultTree)

  return resultTree
}
// 返回数组
const treeToArray = (tree, options = {}) => {
  let config = Object.assign({}, defaults, options)

  const arr = []
  function wlk(t) {
    t.map(c => {
      arr.push(c)
      if (c[config.children]) {
        wlk(c[config.children])
      }
    })
  }
  wlk(tree)
  return arr
}
const arrayToTree = (array, options = { id: 'key', pid: 'parentId' }) => {
  let config = Object.assign({}, defaults, options)
  const hashMap = {}
  array.map(item => {
    hashMap[item[config.id]] = item
  })
  const roots = []
  array.map(item => {
    const parent = hashMap[item[config.pid]]
    if (parent) {
      ;(parent[config.children] || (parent[config.children] = [])).push(item)
    } else {
      roots.push(item)
    }
  })
  return roots
}
const changeChildrenKey = (
  treeData,
  options = {
    newChildren: 'newChildren',
  }
) => {
  let config = Object.assign({}, defaults, options)
  const tData = cloneDeep(treeData)
  function wlk(t) {
    return t.map(item => {
      if (item[config.children]) {
        item[config.newChildren] = wlk(item[config.children])
        delete item.childTreeDto
      }
      return item
    })
  }

  const result = wlk(tData)
  return result
}
export default {
  findParent,
  findAllParents,
  findAllChildren,
  find,
  map,
  filter,
  findAll,
  treeToArray,
  arrayToTree,
  findIndexId,
  findByIndexId,
  changeChildrenKey,
}
